export * from './typography.component';
export * from './typography.style';
